<template>
  <div>
    <a
      :href="`/entities/${entityId}/bank_movements`"
      @click="clearFilters"
      class="inline-flex px-2 py-1 text-sm rounded text-primary bg-sc-gray-lighter"
    >
      <img
        :src="require('@assets/images/left-arrow.svg')"
        class="inline mr-2"
      >
      {{ $t('message.settings.header.goToMovementsButton') }}
    </a>
    <h1
      class="my-4 text-2xl leading-9 md:my-2 md:text-3xl text-primary"
    >
      {{ $t('message.settings.header.settings') }}
    </h1>

    <div
      class="relative flex pt-5 overflow-x-scroll md:pt-10"
    >
      <a
        v-for="(tab, key) in tabs"
        :key="tab.href"
        :href="`/entities/${entityId}/${tab.href}`"
        class="tab-link"
        :class="activeTab == key ? 'active-tab' : 'inactive-tab'"
      >
        {{ tab.name }}
      </a>
      <div class="absolute bottom-0 z-0 w-full border-b border-sc-gray-light" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      tabs: {
        accounts: {
          name: this.$t('message.settings.accountsTab.accounts'),
          href: 'bank_accounts',
        },
        members: {
          name: this.$t('message.settings.membersTab.members'),
          href: 'subscriptions',
        },
        columns: {
          name: this.$t('message.settings.columnsTab.columns'),
          href: 'columns',
        },
        sheets: {
          name: this.$t('message.settings.sheetsTab.sheets'),
          href: 'sheets',
        },
        advanced: {
          name: this.$t('message.settings.advancedTab.advanced'),
          href: 'advanced_settings',
        },
        filters: {
          name: this.$t('message.settings.filtersTab.filters'),
          href: 'filters',
        },
      },
    };
  },
  methods: {
    clearFilters() {
      this.$store.dispatch('clearFilters');
    },
  },
};
</script>
<style lang="scss">
.active-tab {
  @apply text-sc-blue border-b border-sc-blue;

  &:hover {
    @apply text-sc-blue;
  }
}

.inactive-tab {
  @apply text-secondary border-b border-sc-gray-light;

  &:hover {
    @apply text-secondary;
  }
}

.tab-link {
  @apply z-10 pb-1 mr-5 text-sm font-semibold leading-6;
}
</style>
